export default __webpack_public_path__ + "static/media/2-2.8d6609e0.png";